import { AddressTypeEnum } from "@lib/enum"
import dayjs from "dayjs"

export class CustomerModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerModel(), obj)

    newObj.customerGroupMap = obj.customerGroups ?? []
    newObj.customerGroups =
      obj.customerGroups?.map((item) => item.groupId) ?? []
    newObj.birthDate = obj.birthDate ? dayjs(obj.birthDate) : null
    newObj.currentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.CURRENT
    )
    newObj.permanentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.PERMANENT
    )
    newObj.hasCurrentAddress = !!newObj.currentAddress
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CustomerUpdateModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerUpdateModel(), obj)
    newObj.customerAddresses = [
      obj.currentAddress
        ? { addressType: AddressTypeEnum.CURRENT, ...obj.currentAddress }
        : undefined,
      obj.permanentAddress
        ? { addressType: AddressTypeEnum.PERMANENT, ...obj.permanentAddress }
        : undefined,
    ].filter((item) => item !== undefined)
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CustomerForMergeModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerForMergeModel(), obj)

    newObj.birthDate = obj.birthDate ? dayjs(obj.birthDate) : null
    newObj.currentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.CURRENT
    )
    newObj.permanentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.PERMANENT
    )
    newObj.primaryPhoneNumber = obj.customerPhoneNumbers?.find(
      (item) => item.isPrimary
    )?.phoneNumber

    newObj.primaryEmailAddress = obj.customerEmailAddresses?.find(
      (item) => item.isPrimary
    )?.emailAddress

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CustomerContractModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerModel(), obj)

    newObj.currentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.CURRENT
    )
    newObj.permanentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.PERMANENT
    )
    newObj.customerId = obj?.id
    newObj.customerCode = obj?.id.toString() ?? ""

    newObj.customerPhone = obj.customerPhoneNumbers?.find(
      (item) => item.isPrimary
    )?.phoneNumber

    newObj.customerEmail = obj.customerEmailAddresses?.find(
      (item) => item.isPrimary
    )?.emailAddress
    newObj.hasCurrentAddress = !!newObj.currentAddress

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
